import { createStore } from 'vuex'
import app from './modules/app'
export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    app
  }
})
